import * as stateManagement from '#packages/stateManagement';
import constants from '#packages/constants';
import type { Dispatch, StateMapperArgs } from 'types/redux';
import type {
  CustomTemplatePublishSuccessPanelDispatchProps,
  CustomTemplatePublishSuccessPanelMapStateToProps,
} from './customTemplatePublishSuccessPanelTypes';

function mapDispatchToProps(
  dispatch: Dispatch,
): CustomTemplatePublishSuccessPanelDispatchProps {
  const USER_PREFS_KEYS = constants.USER_PREFS.PUBLISH;

  return {
    setDontShowPanelValue: () => {
      dispatch(
        stateManagement.userPreferences.actions.setSiteUserPreferences(
          USER_PREFS_KEYS.POST_PUBLISH_DONT_SHOW_AGAIN,
          Date.now(),
        ),
      );
    },
  };
}

function mapStateToProps({
  state,
  editorAPI,
}: StateMapperArgs): CustomTemplatePublishSuccessPanelMapStateToProps {
  return {
    editorAPI,
    templateId:
      stateManagement.customTemplate.selectors.getCustomTemplateId(state),
  };
}

export { mapStateToProps, mapDispatchToProps };
